import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useDispatch } from "react-redux";
import './MyBookings.css'
import { myAllBookings } from "../../redux/CustomerReducer";
import moment from "moment";
import Swal from "sweetalert2";

import { RiDeleteBin6Line } from "react-icons/ri";

// import EditVehicleDrawer from "../EditVehicleDrawer/EditVehicleDrawer";
import { useState } from "react";
import { useEffect } from "react";
import { getAllVehicles } from "../../redux/AdminReducer";
import { useSelector } from "react-redux";
import { deleteVehicle } from "../../redux/AdminReducer";
// import EditDriverDrawer from "../EditDriverDrawer/EditDriverDrawer";
import { getAllDrivers } from "../../redux/AdminReducer";
import { deleteDriver } from "../../redux/AdminReducer";
import { getCustomers } from "../../redux/AdminReducer";
export default function MyBookings() {
  const [deleteVeh, setDeleteVeh] = useState(0);

  const dispatch = useDispatch();
  const [alertIndex, setAlertIndex] = useState();

 
  const customerData = useSelector(
    (state) => state?.AdminReducer?.getCustomersData
  );
  const myBookingsDataRes = useSelector(
    (state) => state?.CustomerReducer?.myAllBookingsData?.data?.bookings
  );
  const id = useSelector(
    (state) => state?.CustomerReducer?.currentCustomer?.user?._id
  );

  console.log("myBookingsDataRes",myBookingsDataRes)

//   console.log("vehicleDatauserId", userId);
myBookingsDataRes?.map((data)=>{
  console.log("DATTTTT",data)

})

  const deleteIconClicked = (index) => {
    setAlertIndex(index);

    setDeleteVeh(1);
  };

  const noClickedAlert = () => {
    setDeleteVeh(2);
  };

  useEffect(() => {
 
    dispatch(getAllDrivers());
    dispatch(getCustomers());
    
  }, []);

  const yesDeleteClicked = async (data) => {
    // let id = data._id;

    // const response = await dispatch(deleteDriver({ id, driversData }));

    // console.log("responseDeletedVehicle", data);

    // setDeleteVeh(2);
  };

  console.log("idMyBookings",id)
  useEffect(()=>{

   
    dispatch(myAllBookings({id}));

  },[])

  return (
    <div className="mainContainerMyBookings">
        <div className="headingMyBooking">
            My Bookings
        </div>
      <TableContainer component={Paper} className="containerTableBooking">
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow className="rowMyBooking">
              <TableCell>Departure Location</TableCell>
              <TableCell align="right">Arrival Location</TableCell>
              <TableCell align="right">Booking Amount</TableCell>

              <TableCell align="right">Pickup Date & Time</TableCell>
              <TableCell align="right">Return PickUp Date & Time</TableCell>
              <TableCell align="right">Hourly Duration</TableCell>
              
              
            
            
            </TableRow>
          </TableHead>
          <TableBody>
            {myBookingsDataRes?.map((row, index) => (
              <TableRow
                key={row?.name}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
           
                <TableCell align="right">{row?.pickUpLocation}</TableCell>
                <TableCell align="right">{row?.arrivalLocation}</TableCell>


                <TableCell align="right">{parseInt(row?.bookingAmount)}</TableCell>
        
{!row.hourlyDuration&&                <TableCell align="right">{moment(row?.pickUpDatemoment).format("YYYY-MM-DD")}-{row?.pickUpTime}</TableCell>}
{row.hourlyDuration&&                <TableCell align="right">{row.pickUpTime}</TableCell>}
{row.hourlyDuration&&                <TableCell align="right">{row?.returnPickUpTime}</TableCell>}
{!row.hourlyDuration&&             <TableCell align="right">{moment(row?.returnPickUpDatemoment).format("YYYY-MM-DD")}-{row?.returnPickUpTime}</TableCell>}
                <TableCell align="right">{row?.hourlyDuration}</TableCell>

       
              
              
                {/* <TableCell align="right">
                  <RiDeleteBin6Line
                    onClick={() => deleteIconClicked(index)}
                    className="deleteVehicleIcon"
                  />
                </TableCell> */}
                {/* <TableCell align="right" className="editColDataVeh"> */}
                  {/* <FiEdit2/> */}

                  {/* <EditVehicleDrawer data={row}/> */}

                  {/* <EditDriverDrawer data={row}/> */}
                {/* </TableCell> */}

                {deleteVeh === 1 && alertIndex === index && (
                  <div className="mainDeleteCardVehicle">
                    <div className="confirmTxtAlertVehDlt">
                      {" "}
                      You want to delete Vehicle?
                    </div>
                    <div className="topConfirmBtnDeltVeh">
                      <div
                        className="noBtnAlertDltVeh"
                        onClick={noClickedAlert}
                      >
                        No
                      </div>
                      <div
                        className="yesBtnAlertDltVeh"
                        onClick={() => yesDeleteClicked(row)}
                      >
                        Yes
                      </div>
                    </div>
                  </div>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
